__turbopack_context__.v({
  "description": "TB93_W_description",
  "descriptionWrapper": "TB93_W_descriptionWrapper",
  "input": "TB93_W_input",
  "label": "TB93_W_label",
  "required": "TB93_W_required",
  "root": "TB93_W_root",
  "section": "TB93_W_section",
  "wrapper": "TB93_W_wrapper",
});
